import HTTP from '../../../../api/AxiosConfig';

export const getProductsReceivers = () =>
    HTTP.get('/client-configs/products-receivers').finally(
        (response) =>
            new Promise((resolve) => {
                resolve(response);
            }),
    );

export const saveProductsReceiver = (employeeId) =>
    HTTP.put(`/client-configs/products-receivers?employeeId=${employeeId}`);

export const getGroupsAndBudgetConfigs = () =>
    HTTP.get('/client-configs/groups-budget-configs').finally(
        (response) =>
            new Promise((resolve) => {
                resolve(response);
            }),
    );

export const saveGroupsAndBudgetConfigs = (configs) =>
    HTTP.put(`/client-configs/groups-budget-configs`, configs);

export const getClientDayNumber = () =>
    HTTP.get('/client/client-day').finally(
        (response) =>
            new Promise((resolve) => {
                resolve(response);
            }),
    );

export const saveClientDayNumber = (number) => HTTP.post('/client-configs/declare-day?number=' + number);